// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backup-page-container {
  width: 454px;
  height: 278px;
  position: absolute;
  left: calc(50% - 227px);
  top: calc(50% - 139px);
  overflow: hidden;
  z-index: 20;
  opacity: 1;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  border-radius: 5px;
  z-index: 10;
  animation: popup 0.1s ease-in-out 0s 1;
}
.backup-close-icon {
  margin-top: 10px;
  margin-right: 10px;
  float: right;
  font-size: 18px;
  cursor: pointer;
}
@keyframes popup {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  80% {
    opacity: 0.95;
    transform: scale(1.005);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes popout {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

.backup-page-title {
  width: 100%;
  font-size: 18px;
  line-height: 60px;
  opacity: 1;
  text-align: center;
  font-weight: 500;
}
.backup-page-drive-container {
  width: 100%;
  height: calc(100% - 80px);
  position: relative;
  bottom: 10px;
}
.backup-page-list-item {
  float: left;
  width: 93px;
  height: 93px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  box-sizing: border-box;
  margin-right: 10px;
  margin-left: 10px;
}

.backup-page-list-icon {
  font-size: 50px;
  position: relative;
  left: 45px;
  cursor: pointer;
  line-height: 50px !important;
}
.backup-page-list-title {
  width: 150px !important;
  font-size: 14px;
  line-height: 30px;
  opacity: 1;
  width: 100%;
  text-align: center;
  cursor: pointer;
}

.backup-page-close-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  transition: 0.1s;
  width: 38px;
  height: 38px;
}
.backup-page-close-icon:hover {
  border-radius: 50%;
}
.backup-page-option {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  top: 65px;
}
.backup-page-backup {
  width: 200px;
  height: 142px;
  font-size: 18px;
  line-height: 40px;
  opacity: 1;
  text-align: center;
  cursor: pointer;
}
.backup-page-backup:hover {
  border-radius: 10px;
}
.active {
  color: white;
  cursor: pointer;
}
.icon-backup,
.icon-restore {
  display: inline-block;
  font-size: 70px;
  margin-top: 10px;
}
.backup-page-next {
  font-size: 16px;
  line-height: 20px;
  opacity: 1;
  position: absolute;
  bottom: 8px;
  right: 27px;
  cursor: pointer;
  padding: 5px;
  border-radius: 5px;
}
.backup-page-previous {
  font-size: 18px;
  line-height: 20px;
  opacity: 1;
  position: absolute;
  bottom: 21px;
  right: 108px;
  cursor: pointer;
}
.backup-page-backup-selector {
  width: 142px;
  height: 142px;
  opacity: 1;
  animation: popup 0.1s ease-in-out 0s 1;
  margin-left: 54px;
  margin-top: 5px;
  border-radius: 5px;
}
.restore-warning {
  font-size: 12px;
  line-height: 1.25;
  margin-top: 12px;
  position: absolute;
  bottom: 35px;
  padding-left: 20px;
  padding-right: 20px;
  color: rgb(231, 69, 69);
}
.icon-local {
  opacity: 1;
}
.restore-file {
  position: absolute;
  left: 0px;
  bottom: 105px;
  width: 93px;
  height: 93px;
  z-index: 10;
  opacity: 0.5;
  cursor: pointer;
  font-size: 0;
  border-radius: 10px;
  box-sizing: border-box;
  margin-right: 10px;
  margin-left: 10px;
  /* background-color: pink; */
}
::file-selector-button {
  display: none;
}
.backup-page-finish-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.backup-page-finish-icon {
  font-size: 60px;
  margin: 0px;
}
.backup-page-finish-text {
  line-height: 50px;
  font-size: 18px;
}
.backup-source-dropdown {
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 0px;
  font-size: 15px;
  line-height: 18px;
  opacity: 1;
  /* padding-left: 10px; */
  cursor: pointer;
  width: 80px;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/backupDialog/backupDialog.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,sCAAsC;EACtC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;AAIA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,wBAAwB;EACxB,eAAe;EACf,WAAW;AACb","sourcesContent":[".backup-page-container {\n  width: 454px;\n  height: 278px;\n  position: absolute;\n  left: calc(50% - 227px);\n  top: calc(50% - 139px);\n  overflow: hidden;\n  z-index: 20;\n  opacity: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  border-radius: 5px;\n  z-index: 10;\n  animation: popup 0.1s ease-in-out 0s 1;\n}\n.backup-close-icon {\n  margin-top: 10px;\n  margin-right: 10px;\n  float: right;\n  font-size: 18px;\n  cursor: pointer;\n}\n@keyframes popup {\n  0% {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  80% {\n    opacity: 0.95;\n    transform: scale(1.005);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes popout {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n}\n\n.backup-page-title {\n  width: 100%;\n  font-size: 18px;\n  line-height: 60px;\n  opacity: 1;\n  text-align: center;\n  font-weight: 500;\n}\n.backup-page-drive-container {\n  width: 100%;\n  height: calc(100% - 80px);\n  position: relative;\n  bottom: 10px;\n}\n.backup-page-list-item {\n  float: left;\n  width: 93px;\n  height: 93px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  box-sizing: border-box;\n  margin-right: 10px;\n  margin-left: 10px;\n}\n\n.backup-page-list-icon {\n  font-size: 50px;\n  position: relative;\n  left: 45px;\n  cursor: pointer;\n  line-height: 50px !important;\n}\n.backup-page-list-title {\n  width: 150px !important;\n  font-size: 14px;\n  line-height: 30px;\n  opacity: 1;\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n}\n\n.backup-page-close-icon {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  cursor: pointer;\n  transition: 0.1s;\n  width: 38px;\n  height: 38px;\n}\n.backup-page-close-icon:hover {\n  border-radius: 50%;\n}\n.backup-page-option {\n  width: 100%;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  position: absolute;\n  top: 65px;\n}\n.backup-page-backup {\n  width: 200px;\n  height: 142px;\n  font-size: 18px;\n  line-height: 40px;\n  opacity: 1;\n  text-align: center;\n  cursor: pointer;\n}\n.backup-page-backup:hover {\n  border-radius: 10px;\n}\n.active {\n  color: white;\n  cursor: pointer;\n}\n.icon-backup,\n.icon-restore {\n  display: inline-block;\n  font-size: 70px;\n  margin-top: 10px;\n}\n.backup-page-next {\n  font-size: 16px;\n  line-height: 20px;\n  opacity: 1;\n  position: absolute;\n  bottom: 8px;\n  right: 27px;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 5px;\n}\n.backup-page-previous {\n  font-size: 18px;\n  line-height: 20px;\n  opacity: 1;\n  position: absolute;\n  bottom: 21px;\n  right: 108px;\n  cursor: pointer;\n}\n.backup-page-backup-selector {\n  width: 142px;\n  height: 142px;\n  opacity: 1;\n  animation: popup 0.1s ease-in-out 0s 1;\n  margin-left: 54px;\n  margin-top: 5px;\n  border-radius: 5px;\n}\n.restore-warning {\n  font-size: 12px;\n  line-height: 1.25;\n  margin-top: 12px;\n  position: absolute;\n  bottom: 35px;\n  padding-left: 20px;\n  padding-right: 20px;\n  color: rgb(231, 69, 69);\n}\n.icon-local {\n  opacity: 1;\n}\n.restore-file {\n  position: absolute;\n  left: 0px;\n  bottom: 105px;\n  width: 93px;\n  height: 93px;\n  z-index: 10;\n  opacity: 0.5;\n  cursor: pointer;\n  font-size: 0;\n  border-radius: 10px;\n  box-sizing: border-box;\n  margin-right: 10px;\n  margin-left: 10px;\n  /* background-color: pink; */\n}\n::-webkit-file-upload-button {\n  display: none;\n}\n::file-selector-button {\n  display: none;\n}\n.backup-page-finish-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.backup-page-finish-icon {\n  font-size: 60px;\n  margin: 0px;\n}\n.backup-page-finish-text {\n  line-height: 50px;\n  font-size: 18px;\n}\n.backup-source-dropdown {\n  display: inline-block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  border: 0px;\n  font-size: 15px;\n  line-height: 18px;\n  opacity: 1;\n  /* padding-left: 10px; */\n  cursor: pointer;\n  width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
